// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Aura Operations API
 * API to manage aura-operations
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const DbOperationStatusType = {
  OperationStatusTypeTriggered: 'triggered',
  OperationStatusTypePreFlightLookup: 'pre-flight-lookup',
  OperationStatusTypeRunning: 'running',
  OperationStatusTypeSucceeded: 'succeeded',
  OperationStatusTypeFailed: 'failed',
  OperationStatusTypeAborted: 'aborted',
} as const;
export type DbOperationStatusType =
  (typeof DbOperationStatusType)[keyof typeof DbOperationStatusType];

export function instanceOfDbOperationStatusType(value: any): boolean {
  for (const key in DbOperationStatusType) {
    if (Object.prototype.hasOwnProperty.call(DbOperationStatusType, key)) {
      if (
        DbOperationStatusType[key as keyof typeof DbOperationStatusType] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function DbOperationStatusTypeFromJSON(
  json: any,
): DbOperationStatusType {
  return DbOperationStatusTypeFromJSONTyped(json, false);
}

export function DbOperationStatusTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DbOperationStatusType {
  return json as DbOperationStatusType;
}

export function DbOperationStatusTypeToJSON(
  value?: DbOperationStatusType | null,
): any {
  return value as any;
}

export function DbOperationStatusTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): DbOperationStatusType {
  return value as DbOperationStatusType;
}
